import { createContext, useContext } from "react";

export interface LaunchDateFocusApi {
  version: number;
  consume: () => boolean;
}

export const LaunchDateFocusContext = createContext<LaunchDateFocusApi>({ version: 0, consume: () => false });

export const useLaunchDateFocus = () => useContext(LaunchDateFocusContext);
